import classnames from 'classnames';
import React from 'react';
import { Field, useField } from 'react-final-form';

import { FileInput } from '../../../../interfaces';
import { useFormInput } from '../../../../libs/hooks';
import { InputLabelComponent } from '../../input-label';
import { InputMessageComponent } from '../../input-message';

export const FileUploadComponent: React.FC<FileInput> = React.memo((props: FileInput) => {
  const {
    accept,
    className,
    description,
    disabled,
    label,
    name,
    required = true,
    validators,
    ...rest
  } = props;

  const { id, texts, validate } = useFormInput({
    description,
    disabled,
    label,
    name,
    required,
    validators,
  });

  const filesizeField = useField(`${id}-filesize`);
  const filetypeField = useField(`${id}-filetype`);

  return (
    <Field<FileList> name={id} type="file" validate={validate}>
      {/*
        @NOTE do not remove `value` argument from props
        it prevent to be parsed and failed into a react-final-form context
        @see https://github.com/final-form/react-final-form/issues/663#issue-513244910
      */}
      {({ input: { onChange, value, ...input }, meta }) => {
        const error = meta.touched && meta.error;
        return (
          <div
            className={classnames('fr-upload-group fr-mt-3 fr-mb-4w', className, {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              'fr-input-group--error': !!error,
            })}>
            <InputLabelComponent bolder disabled={disabled} id={id} texts={texts} />
            <input
              {...rest}
              {...input}
              accept={accept}
              aria-describedby={`${id}-messages`}
              className="fr-upload"
              id={id}
              multiple={false}
              onChange={({ target }) => {
                const isEmpty = !target.value || !target.value.trim();
                const files = isEmpty ? undefined : target.files;
                const { size, type } = (files && files[0]) || { size: 0, type: undefined };

                filesizeField.input.onChange(size);
                filetypeField.input.onChange(type);
                onChange(files);
              }}
            />
            <InputMessageComponent error={error} id={id} />
            <input {...filesizeField.input} type="hidden" />
            <input {...filetypeField.input} type="hidden" />
          </div>
        );
      }}
    </Field>
  );
});

FileUploadComponent.displayName = 'FileUploadComponent';
